import React, { useRef, useLayoutEffect, useState } from 'react';
import { List } from 'antd';
import { Document} from "../../types";
import DocumentListItem from './DocumentListItem';
import {useElementSize} from "../../hooks/useElementSize";

export interface DocumentListProps {
    documents: Document[];
    actions: (document: Document) => React.ReactNode[];
    containerRef?: React.RefObject<HTMLDivElement>;
    style?: React.CSSProperties;
    offset?: number; // корректировка от высоты контейнера, по умолчанию 0
}

const DocumentList: React.FC<DocumentListProps> = ({ documents, actions, containerRef, style, offset = 0 }) => {
    // Если родитель не передал ref контейнера, используем внутренний
    const internalContainerRef = useRef<HTMLDivElement>(null);
    const usedContainerRef = containerRef || internalContainerRef;

    // Получаем реальную высоту контейнера с помощью хука
    const containerHeight = useElementSize(usedContainerRef);

    // Измеряем высоту первого элемента списка
    const firstItemRef = useRef<HTMLDivElement | null>(null);
    const [itemHeight, setItemHeight] = useState<number>(0);

    useLayoutEffect(() => {
        if (firstItemRef.current) {
            setItemHeight(firstItemRef.current.offsetHeight);
        }
    }, [documents]);

    // Вычисляем pageSize на основе доступной высоты и высоты элемента
    const pageSize = itemHeight > 0 ? Math.floor((containerHeight - offset) / itemHeight) : 5;

    return (
        <div ref={usedContainerRef} style={style}>
            <List
                itemLayout="horizontal"
                dataSource={documents}
                pagination={{
                    pageSize: pageSize,
                }}
                renderItem={(doc: Document, index) => {
                    // Для измерения высоты первого элемента
                    const refCallback = (el: HTMLDivElement | null) => {
                        if (index === 0) {
                            firstItemRef.current = el;
                        }
                    };

                    return (
                        <DocumentListItem
                            ref={refCallback}
                            document={doc}
                            actions={actions(doc)}
                        />
                    );
                }}
                locale={{
                    emptyText: (
                        <div
                            style={{
                                height: '200px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            Документов пока нет
                        </div>
                    ),
                }}
            />

        </div>
    );
};

export default DocumentList;
